export default __webpack_public_path__ + "static/media/2.e86494e4.mp4";